import React from 'react'
import { supabase } from '@/lib/supabase'

export function useLastPrice(symbol: string | undefined | null, pollMs: number = 60000) {
  const [price, setPrice] = React.useState<number | null>(null)

  React.useEffect(() => {
    if (!symbol) return
    let cancelled = false

    const fetchPrice = async () => {
      try {
        const { data, error } = await supabase.rpc('last_price_5m', { p_symbol: symbol })
        if (cancelled) return
        if (!error && typeof data === 'number') {
          setPrice(data)
        }
      } catch {
        if (!cancelled) setPrice(null)
      }
    }

    fetchPrice()
    const id = pollMs > 0 ? setInterval(fetchPrice, pollMs) : null

    return () => {
      cancelled = true
      if (id) clearInterval(id)
    }
  }, [symbol, pollMs])

  return price
}

